/**
 * Tras PATCH de observación/verificación, el padre puede seguir con el detalle
 * viejo. Si adoptamos ese padre, el input se vacía hasta pulsar refresh.
 */
export function shouldAdoptParentCierreDetalle(opts: {
  dirty: boolean;
  localUpdatedAt?: string | null;
  parentUpdatedAt?: string | null;
}): boolean {
  if (opts.dirty) return false;
  const local = String(opts.localUpdatedAt || "");
  const parent = String(opts.parentUpdatedAt || "");
  if (local && parent && local > parent) return false;
  if (local && !parent) return false;
  return true;
}
